export default "__VITE_ASSET__HjNPEv$e__"